<template>
    <div ref="root">
        <app-modulebackground
            :module-id="module.id"
            custom-class="brands__background module__background"
        ></app-modulebackground>
        <div
            class="brands__container module__container"
            v-bind:class="{
                container__boxed: [1, 2, 3, 4].includes(module.layout.type),
                'container__boxed--half': [5, 6].includes(module.layout.type)
            }"
        >
            <div class="brands__inner module__inner">
                <div class="brands__inner--main module__inner--main">
                    <div
                        class="brands__inner-row module__inner-row"
                        v-if="module.data.title || module.data.subtitle"
                    >
                        <div class="brands__inner-col module__inner-col">
                            <div class="brands__header module__header">
                                <h2
                                    class="brands__title module__title font-h2 color-h2"
                                    v-if="module.data.title"
                                    v-html="module.data.title"
                                ></h2>
                                <h3
                                    class="brands__subtitle module__subtitle font-h3 color-h3"
                                    v-if="module.data.subtitle"
                                    v-html="module.data.subtitle"
                                ></h3>
                            </div>
                        </div>
                    </div>
                    <div class="brands__inner-row module__inner-row">
                        <div class="brands__inner-col module__inner-col">
                            <div class="brands__content-block module__content-block">
                                <div
                                    class="brands__content-block--left module__content-block--left"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="module.data.text"
                                >
                                    <div class="brands__inner-row module__inner-row">
                                        <div class="brands__inner-col module__inner-col">
                                            <div
                                                class="brands__text module__text font-p color-p module__cms"
                                                v-if="module.data.text"
                                                v-html="module.data.text"
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                                <div
                                    class="brands__content-block--right module__content-block--right"
                                    v-bind:class="{
                                        'col__width--full': [1, 2, 3, 4, 5, 6].includes(
                                            module.layout.type
                                        )
                                    }"
                                    v-if="items && Array.isArray(items) && items.length > 0"
                                >
                                    <div class="brands__inner-row module__inner-row">
                                        <div class="brands__inner-col module__inner-col">
                                            <div
                                                ref="slider"
                                                class="brands__images"
                                                per-page="6"
                                                per-page-lg="4"
                                                per-page-md="3"
                                                per-page-sm="1"
                                                v-bind:class="{
                                                    slider:
                                                        [3, 4].includes(module.layout.type) &&
                                                        items.length > 6
                                                }"
                                            >
                                                <ul
                                                    class="brands__list"
                                                    v-bind:class="{
                                                        module__list: [1, 2, 5, 6].includes(
                                                            module.layout.type
                                                        )
                                                    }"
                                                >
                                                    <li
                                                        v-for="items__value in items"
                                                        v-bind:key="items__value.id"
                                                        :data-preset-id="items__value.preset_id"
                                                        class="brands__list-item module__list-item"
                                                        v-bind:class="{
                                                            'col__width--one-sixth': [
                                                                1,
                                                                2
                                                            ].includes(module.layout.type),
                                                            'col__width--one-third': [
                                                                5,
                                                                6
                                                            ].includes(module.layout.type)
                                                        }"
                                                    >
                                                        <div
                                                            class="brands__teaser-box module__teaser-box--horizontal"
                                                            v-if="
                                                                items__value.data &&
                                                                    items__value.data.link
                                                            "
                                                        >
                                                            <a
                                                                v-bind:href="items__value.data.link"
                                                                class="brands__link module__link d-inline-block"
                                                                target="_blank"
                                                            >
                                                                <app-moduleimage
                                                                    v-if="
                                                                        items__value.data &&
                                                                            items__value.data
                                                                                .icon &&
                                                                            [1, 2, 3, 4].includes(
                                                                                module.layout.type
                                                                            )
                                                                    "
                                                                    :data="items__value.data.icon"
                                                                    :width="175"
                                                                    :height="175"
                                                                    :tag="'img'"
                                                                    :custom-class="
                                                                        'brands__teaser-image module__image'
                                                                    "
                                                                    :alt-tag="
                                                                        items__value.data.name
                                                                            ? items__value.data.name
                                                                            : ''
                                                                    "
                                                                ></app-moduleimage>
                                                                <div
                                                                    v-if="
                                                                        items__value.data &&
                                                                            !items__value.data
                                                                                .icon &&
                                                                            [1, 2, 3, 4].includes(
                                                                                module.layout.type
                                                                            )
                                                                    "
                                                                    class="image-container image-container--img brands__teaser-image module__image"
                                                                >
                                                                    <img
                                                                        v-bind:src="
                                                                            generateMediaUrl({
                                                                                path:
                                                                                    'media/images/brands/default/1.jpg',
                                                                                w: 175,
                                                                                h: 175
                                                                            })
                                                                        "
                                                                        alt=""
                                                                    />
                                                                </div>
                                                                <div
                                                                    v-if="
                                                                        items__value.data &&
                                                                            !items__value.data
                                                                                .icon &&
                                                                            items__value.data
                                                                                .name &&
                                                                            [1, 2, 3, 4].includes(
                                                                                module.layout.type
                                                                            )
                                                                    "
                                                                    class="brands__name font-p font-bold"
                                                                    v-html="items__value.data.name"
                                                                ></div>
                                                                <div
                                                                    v-if="
                                                                        [5, 6].includes(
                                                                            module.layout.type
                                                                        )
                                                                    "
                                                                    class="brands__list-item-title brands__teaser-box-text font-bold"
                                                                >
                                                                    <div
                                                                        class="module__label font-bold color-p"
                                                                    >
                                                                        <span>»</span>
                                                                        {{ items__value.data.name }}
                                                                    </div>
                                                                </div>
                                                            </a>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="brands__inner-row module__inner-row"
                        v-if="
                            (module.data.link && module.data.link.active) ||
                                (module.data.link2 && module.data.link2.active) ||
                                (module.data.link3 && module.data.link3.active)
                        "
                    >
                        <div class="brands__inner-col module__inner-col">
                            <div class="brands__cta module__cta">
                                <app-modulebutton
                                    :data="module.data.link"
                                    :custom-class="
                                        'brands__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link2"
                                    :custom-class="
                                        'brands__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                                <app-modulebutton
                                    :data="module.data.link3"
                                    :custom-class="
                                        'brands__cta-btn module__cta-btn font-button color-button bg-color-button'
                                    "
                                ></app-modulebutton>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ModuleButton from '@/components/assorted/ModuleButton';
import ModuleImage from '@/components/assorted/ModuleImage';
import ModuleBackground from '@/components/assorted/ModuleBackground';
import { SliderMixin } from '@/mixins/SliderMixin';
import Brands from '@/external/modules/Brands';

export default {
    data() {
        return {};
    },
    mixins: [SliderMixin],
    components: {
        'app-modulebutton': ModuleButton,
        'app-moduleimage': ModuleImage,
        'app-modulebackground': ModuleBackground
    },
    methods: {},
    computed: {
        ...mapGetters(['getListItems', 'getRandomImageInNamespace', 'generateMediaUrl']),
        items() {
            return this.getListItems('deha.user.misc.brands');
        }
    },
    created() {},
    mounted() {
        let i = new Brands();
        i.init(this.$refs.root);
    },
    updated() {
        let i = new Brands();
        i.init(this.$refs.root);
    },
    props: {
        module: Object
    }
};
</script>
